<template>
  <!-- 批量添加区域组件 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="50%"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('newarea.batch')"
      class-name="vertical-center-modal"
    >
    <Spin v-if="spinShow" size="large" fix></Spin>
      <div class="modalContainer modalHeight">
        <Form :label-width="130" label-colon>
          <!-- 选中批量添加的类型：连续添加、矩阵添加 -->
          <FormItem :label="$t('area.areaType')" required>
            <div class="radio-box">
              <span
                :class="areaFlag === 2 ? 'active-box' : ''"
                @click="areaTypeChange(2)"
              >
                {{ $t("newarea.batch1") }}
              </span>
              <span
                :class="areaFlag === 3 ? 'active-box' : ''"
                @click="areaTypeChange(3)"
              >
                {{ $t("newarea.batch2") }}
              </span>
            </div>
          </FormItem>
        </Form>
        <div>
          <!-- 连续添加 -->
          <type2
            v-if="Number(areaFlag) === 2"
            ref="type2"
            :current-node="currentNode"
          
            @closeBox="closeModal"
            @updateTree="updateTree"
            @changeSpinShow="changeSpinShow"
          ></type2>
        </div>
        <div>
          <!-- 矩阵添加 -->
          <type3
            v-if="Number(areaFlag) === 3"
            ref="type3"
            :current-node="currentNode"
            
            @closeBox="closeModal"
            @updateTree="updateTree"
            @changeSpinShow="changeSpinShow"
          ></type3>
        </div>
      </div>
    </Modal>
    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal
        ref="resultModal"
        :type="modalType"
        @afterComfirm="closeModal"
      ></modal>
    </div>
  </div>
</template>

<script>
import type2 from "./type2";
import type3 from "./type3";
export default {
  name: "ModalBox",
  components: {
    type2,
    type3,
  },
  props: {
    currentNode: {
      // 左侧树选中的节点信息
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      spinShow: false,
      dialogVisible: false,
      addForm: {},
      areaFlag: 2, // 批量添加类型  2连续添加；3矩阵添加
      modalType: false,
      areaType: 0, // 0 add 1 edit 2 next
    };
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible === false) {
          // 弹窗关闭 清空数据
          this.$refs.type2.clearForm();
          this.$refs.type3.clearForm();

          this.$emit("getList");
          this.$emit("getNewTopArea");

          this.areaFlag = 2;
          this.addForm = {};
        } else if (this.dialogVisible === true) {
          this.areaFlag = 2;
          this.$refs.type2.addForm.namePath = this.$refs.type2.setNamePath(); // 设置所属上级区域的namePath
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.dialogVisible = false;
    },
    // 选择批量操作类型
    areaTypeChange(select) {
      this.areaFlag = select;
      this.$forceUpdate();
    },
    updateTree() {
      this.$emit("updateTree");
    },
    changeSpinShow(bool) {
      this.spinShow = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-box {
  float: left;
  padding: 5px 10px;
  border-radius: 20px;
  box-sizing: content-box;
  background: #e6f1ff;

  span {
    padding: 5px 20px;
    height: 30px;
    text-align: center;
    color: #0e75fe;
    cursor: pointer;
  }
  .active-box {
    border-radius: 20px;
    background: #fff;
  }
}
</style>
